/*
 * MRCH choose-a-product earnings estimator.
 * Classic script, loaded with `defer` from sections/mrch-choose-product.liquid.
 */
(function () {
  'use strict';

  function money(value) {
    return Number(value).toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD',
      maximumFractionDigits: 2,
    });
  }

  function productFromButton(btn) {
    return {
      id: btn.getAttribute('data-id'),
      label: btn.getAttribute('data-label') || '',
      cost: parseFloat(btn.getAttribute('data-cost')),
      defaultPrice: parseFloat(btn.getAttribute('data-default-price')),
    };
  }

  function bind(root) {
    if (!root || root.getAttribute('data-mrch-bound') === '1') return;
    root.setAttribute('data-mrch-bound', '1');

    var buttons = root.querySelectorAll('[data-choose-product]');
    var priceInput = root.querySelector('[data-price-input]');
    var salesInput = root.querySelector('[data-sales-input]');
    var priceValue = root.querySelector('[data-price-value]');
    var salesValue = root.querySelector('[data-sales-value]');
    var costCopy = root.querySelector('[data-cost-copy]');
    var unitLine = root.querySelector('[data-unit-line]');
    var monthlyEl = root.querySelector('[data-monthly]');
    var active = root.querySelector('[data-choose-product][aria-pressed="true"]') || buttons[0];
    if (!active || !priceInput || !salesInput) return;

    var product = productFromButton(active);

    function setActive(btn) {
      for (var i = 0; i < buttons.length; i++) {
        var on = buttons[i] === btn;
        buttons[i].setAttribute('aria-pressed', on ? 'true' : 'false');
        buttons[i].classList.toggle('is-active', on);
      }
    }

    function render() {
      var price = parseFloat(priceInput.value);
      var sales = parseInt(salesInput.value, 10);
      if (isNaN(price)) price = product.defaultPrice;
      if (isNaN(sales)) sales = 2;
      var unit = Math.max(0, price - product.cost);
      var monthly = unit * sales * 30;
      if (priceValue) priceValue.textContent = money(price);
      if (salesValue) salesValue.textContent = String(sales);
      if (costCopy) costCopy.textContent = 'Production Cost: ' + money(product.cost);
      if (unitLine) unitLine.textContent = money(unit) + ' on the ' + product.label.toLowerCase();
      if (monthlyEl) monthlyEl.textContent = money(monthly);
    }

    function applyProduct(btn) {
      product = productFromButton(btn);
      setActive(btn);
      var min = Math.ceil(product.cost) + 1;
      priceInput.min = String(min);
      priceInput.max = '80';
      priceInput.value = String(product.defaultPrice);
      render();
    }

    for (var i = 0; i < buttons.length; i++) {
      buttons[i].addEventListener('click', function (event) {
        applyProduct(event.currentTarget);
      });
    }
    priceInput.addEventListener('input', render);
    salesInput.addEventListener('input', render);
    applyProduct(active);
  }

  function bindAll(scope) {
    var roots = (scope || document).querySelectorAll('[data-mrch-choose-product]');
    for (var i = 0; i < roots.length; i++) bind(roots[i]);
  }

  function onReady() {
    bindAll(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }

  document.addEventListener('shopify:section:load', function (event) {
    bindAll(event.target);
  });
})();
